import React, { ReactNode } from 'react'
import { motion } from 'framer-motion'
import { useTheme } from '@mui/material/styles'

interface AnimatedAccordionWrapperProps {
  children: ReactNode
}

const AnimatedAccordionWrapper = (props: AnimatedAccordionWrapperProps) => {
  const theme = useTheme()
  return (
    <motion.section
      key='content'
      initial='collapsed'
      animate='open'
      exit='collapsed'
      variants={{
        open: {
          opacity: 1,
          height: 'auto',
          // height duration set to 0 since anything bigger causes weird behavior
          // with connect widget container animation
          transition: { duration: 0.3, height: { duration: 0 } },
        },
        collapsed: {
          opacity: 0,
          height: 0,
          transition: { duration: 0.1, opacity: { duration: 0.1 } },
        },
      }}
      style={{
        marginBottom: theme.spacing(1.25),
        width: '100%',
      }}
    >
      {props.children}
    </motion.section>
  )
}

export default AnimatedAccordionWrapper
